<template>
  <div>
    <h3 style="color:#143150"><b>{{start}}. 웹 악성코드 유포지 탐지 (WMDS)</b></h3><br>
      <b-row style="padding-left:25px;">
        <b-col>
          <h4><b>{{start}}.1 요약</b></h4>
          <b-row style="padding-left:25px;">
            <b-col><br>
              <h5><b>{{start}}.1.1. 기본 정보</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">사용자명</th>
                    <th style="background-Color:#3D63BA; text-align: center; background-Color:#f0f3f5;">{{auth.profile.username}}</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">기간</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{from}} ~ {{to}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.2. 웹 사이트 현황</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">현황</th>
                    <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">합계</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">사용량</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{wmds && wmds.site_list_alive && wmds.site_list_alive.length || 0}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.3. 도메인 & 웹 악성코드 유포지 모니터링 현황</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; color:#f0f3f5; text-align: center; width:40%">이벤트</th>
                    <th style="background-Color:#3D63BA; text-align: center; color:#f0f3f5;">합계</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">점검 사이트 수</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{(wmds && wmds.total_scan ? wmds.total_scan : 0) | number}}</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">점검 페이지 수</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{(wmds && wmds.total_page ? wmds.total_page : 0) | number }}</th>
                  </tr>
                  <tr>
                    <th style="border-top:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">탐지 수</th>
                    <th style="border-top:1px solid; background-Color:#f0f3f5; text-align: center;">{{(wmds && wmds.total_detect ? wmds.total_detect : 0) | number}}</th>
                  </tr>
                </tbody>
              </table>
              <h5><b>{{start}}.1.4. 도메인 & 웹 악성코드 유포지 모니터링 상세 현황</b></h5>
              <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                <tbody>
                  <tr>
                    <th class="table-f1" style="width:40%" colspan="5">도메인</th>
                  </tr>
                  <tr>
                    <th class="table-f1" style="width:40%" colspan="2">이름</th>
                    <th class="table-f1" >FQDN</th>
                    <th class="table-f1" >상태</th>
                    <th class="table-f1" >삭제</th>
                  </tr>
                  <tr v-for="WMDS_5_1_4 in wmds.site_list" :key="WMDS_5_1_4.id">
                    <th class="border-f1" colspan="2">{{WMDS_5_1_4.name}}</th>
                    <th class="border-f1">{{WMDS_5_1_4.fqdn}}</th>
                    <th class="border-f1">
                      <b-badge :variant="WMDS_5_1_4.is_del ? '' : 'success'">{{WMDS_5_1_4.is_del ? '미사용' : '사용'}}</b-badge>
                    </th>
                    <th class="border-f1">
                      <span v-if="WMDS_5_1_4.is_del"> {{ WMDS_5_1_4.deleted_at | datetime }} </span>
                      <span v-else>-</span>
                    </th>
                  </tr>
                  <tr v-if="wmds.site_list.length < 1">
                    <th class="border-f1" colspan="2">N/A</th>
                    <th class="border-f1">N/A</th>
                    <th class="border-f1">N/A</th>
                    <th class="border-f1">N/A</th>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
          <h4><b>{{start}}.2 모니터링 현황</b></h4>
          <b-row style="padding-left:25px;">
            <b-col><br>
              <h5><b>{{start}}.2.1. 일별 탐지 이벤트 (Total)</b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.2.1.1. 일별 탐지 이벤트 (Total)</b></h5>
                  <line-chart :chartData="WMDS_Daily_Detecting" :options="WMDS_Daily_Detecting.options"></line-chart>
                </b-col>
              </b-row>
              <hr>
              <h5><b>{{start}}.2.2. 탐지 이벤트</b></h5>
              <b-row v-for="(WMDS_5_2_2_1, index) in wmds.domain_check_table" :key="WMDS_5_2_2_1.name + '_' + index" style="padding-left:25px;">
                <b-col>
                  <h5 v-if="WMDS_5_2_2_1.is_del"><b>{{start}}.2.2.{{index + 1}} 일별 탐지 ({{WMDS_5_2_2_1.name}}) - Deleted {{WMDS_5_2_2_1.deleted_at | date}}</b></h5>
                  <h5 v-else><b>{{start}}.2.2.1. 일별 탐지 ({{WMDS_5_2_2_1.name}})</b></h5>
                  <line-chart :options="WMDS_5_2_2_1.chart.options" :chartData="WMDS_5_2_2_1.chart"></line-chart>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <line-chart v-if="wmds.domain_check_table.length < 1" :chartData="DEFAULT_CHART_DATA"></line-chart>
                </b-col>
              </b-row>
              <hr>
              <h5><b>{{start}}.2.3. 도메인 탐지 이벤트(탐지 사이트만 표시)</b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.2.3.1. 도메인 탐지 이벤트 요약 <small class="float-right">최근 10개</small></b></h5> </b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr class="table-f1" >
                        <th class="table-f1"  rowspan="2">이름 (FQDN)</th>
                        <th class="table-f1" >이벤트</th>
                      </tr>
                      <tr class="table-f1" >
                        <th class="table-f1" >탐지</th>
                      </tr>
                      <tr class="border-f1" v-for="WMDS_5_2_3_1 in wmds.top_n_detect_domain" :key="WMDS_5_2_3_1.id">
                        <th class="border-f1">{{WMDS_5_2_3_1.name}} ({{WMDS_5_2_3_1.domain}})</th>
                        <th class="border-f1">{{WMDS_5_2_3_1.data.length | number}}</th>
                      </tr>
                      <tr class="border-f1" v-if="wmds.top_n_detect_domain.length < 1">
                        <th class="border-f1">N/A</th>
                        <th class="border-f1">N/A</th>
                      </tr>
                    </tbody>
                  </table>
                  <div v-for="(WMDS_5_2_3_2, index) in wmds.top_n_detect_domain" :key="WMDS_5_2_3_2.id">
                    <div v-if="WMDS_5_2_3_2.data.length > 0">
                      <h5><b>{{start}}.2.3.{{index + 2}} 탐지 이벤트 ({{WMDS_5_2_3_2.domain}}) <small class="float-right">최근 10개</small> </b></h5>
                      <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                        <tbody v-for="WMDS_5_2_3_3_1, index in WMDS_5_2_3_2.data" :key="WMDS_5_2_3_3_1.id">
                          <tr v-if="index == 0">
                            <th class="table-f1" >구분</th>
                            <th class="table-f1" >위험도</th>
                            <!-- <th class="table-f1" >Code</th> -->
                            <!-- <th class="table-f1" >URL</th> -->
                            <th class="table-f1" colspan="2" >상세</th>
                          </tr>

                          <tr >
                            <th rowspan="3" class="p-2" style="border:1px solid; min-width:60px; width:60px;">{{codes.WMDS_TYPE[WMDS_5_2_3_3_1.type]}}</th>
                            <th rowspan="3" class="p-2" style="border:1px solid; min-width:60px; width:60px;">{{codes.WMDS_PATTRN_LEVEL[WMDS_5_2_3_3_1.level]}}</th>
                            <!-- <th class="p-2" style="border:1px solid; text-align: left; width:300px;">{{WMDS_5_2_3_3_1.code | truncate(100) }}</th>
                            <th class="p-2" style="border:1px solid; text-align: left; width:300px;">{{WMDS_5_2_3_3_1.url | truncate(100)}}</th> -->
                          </tr>
                          <tr>
                            <th class="p-2" style="border:1px solid; min-width:50px;">Code</th>
                            <th class="p-2" style="border:1px solid; min-width:50px;"> {{ WMDS_5_2_3_3_1.code | truncate(100) }} </th>
                          </tr>
                          <tr >
                            <th class="p-2" style="border:1px solid; min-width:50px;">URL</th>
                            <th class="p-2" style="border:1px solid; min-width:50px;"> {{ WMDS_5_2_3_3_1.url | truncate(100) }} </th>
                          </tr>

                        </tbody>
                      </table>
                    </div>
                    <!-- 코드가 없는 경우 내용이 없음 -->
                    <div v-else>
                      <h5><b>{{start}}.2.3.{{index + 2}} 탐지 이벤트 ({{WMDS_5_2_3_2.fqdn}}) <small class="float-right">최근 10개</small> </b></h5>
                      <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                        <tbody>
                          <tr>
                            <!-- <th class="table-f1" >Name</th> -->
                            <th class="table-f1" >Code</th>
                            <th class="table-f1" >URL</th>
                          </tr>
                          <tr>
                            <!-- <th class="p-2 border-f1">N/A</th> -->
                            <!-- <th class="p-2" style="border:1px solid;">{{WMDS_5_2_3_2.rs_list.code ? WMDS_5_2_3_2.rs_list.code : 'N/A' }}</th>
                            <th class="p-2" style="border:1px solid;">{{WMDS_5_2_3_2.rs_list.url ? WMDS_5_2_3_2.rs_list.url : 'N/A'}}</th> -->
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <h4><b>{{start}}.3 관리 현황</b></h4>
          <b-row style="padding-left:25px;">
            <b-col>
              <h5><b>{{start}}.3.1. 웹 악성코드 유포지 및 경유지 패턴 현황 </b></h5>
              <b-row style="padding-left:25px;">
                <b-col>
                  <h5><b>{{start}}.3.1.1. 업데이트 수</b></h5>
                  <table style="width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr>
                        <th colspan="2" class="table-f1" style="width:40%">
                          패턴
                        </th>
                      </tr>
                      <tr>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">합게</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">업데이트 수</th>
                      </tr>
                      <tr>
                        <th class="border-bg-f1">{{ (wmds && wmds.pattern ? wmds.pattern.total : 0) | number }}</th>
                        <th class="border-bg-f1">{{ (wmds && wmds.pattern ? wmds.pattern.updated : 0) | number }}</th>
                        <!-- 이번달 -->
                      </tr>
                    </tbody>
                  </table>
                  <!-- <h5><b>{{start}}.3.1.2. Daily update</b></h5>
                  <line-chart :chartData="WMDS_Daily_Pattern"></line-chart>  -->
                  <hr>
                  <h5><b>{{start}}.3.1.2. 패턴 정보 <small class="float-right">최근 10개</small></b></h5>
                  <table style="word-break:break-all; width:100%; max-width:100%; border:2px solid; text-align: center; box-sizing: border-box; border-collapse: collapse; margin-bottom: 20px;">
                    <tbody>
                      <tr>
                        <th class="table-f1" style="width:100px;">날짜</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Level</th>
                        <th style="border:1px solid; background-Color:#3D63BA; text-align: center; color:#f0f3f5;">Code</th>
                      </tr>
                      <tr v-for="WMDS_5_4_1_3, index in wmds.pattern.pattern_list" :key="WMDS_5_4_1_3.created_at + '_' + index">
                        <th class="p-2 border-bg-f1">{{WMDS_5_4_1_3.created_at | date}}</th>
                        <th class="p-2 border-bg-f1">{{codes.WMDS_PATTRN_LEVEL[WMDS_5_4_1_3.level]}}</th>
                        <th class="p-2" style="border:1px solid; background-Color:#f0f3f5; text-align: left;">{{WMDS_5_4_1_3.code | truncate(30) }}</th>
                      </tr>
                      <tr v-if="wmds.pattern.pattern_list.length < 1">
                        <th class="border-bg-f1">N/A</th>
                        <th class="border-bg-f1">N/A</th>
                        <th class="border-bg-f1">N/A</th>
                      </tr>
                    </tbody>
                  </table>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
  </div>
</template>

<script>

// chart
import lineChart from '../../chart/MainChart';
import BarChart from '../../chart/BarChart';
import DoughnutChart from '../../chart/DoughnutChart';
import StackedVerticalBarChart from '../../chart/StackedVerticalBarChart'

// lib
import auth from '@/f1/service/auth';
import codes from '@/f1/codes';
import _ from 'lodash'
import Custom from '@/f1/service/custom';

export default {
  name:'ReportWMDS',
  props: [
    'start',
    'end',
    'from',
    'to',
    "wmds",
    'wmds_recent',
    'wmds_summary',
    'WMDS_Daily_Detecting_Total',
    'WMDS_Daily_Detecting_Domain',
    'WMDS_Daily_Detecting',
    'WMDS_Daily_Pattern',
  ],
  components: {
    // chart
    lineChart,
    DoughnutChart,
    BarChart,
    StackedVerticalBarChart,

  },
  data: () => {
    return {
      custom : Custom.custom_default,
      codes,
      auth,
      DEFAULT_CHART_DATA : {
        labels: [],
        datasets: [
          {
            label: 'No have value',
            backgroundColor: '#f87979',
            data: []
          }
        ]
      }
    }
  },
  computed: {
  },
  methods: {
    // Regex	Hash	URL	SSDEEP	Obfuscation
    // wsfinder_rule(setting) { return _.map((JSON.parse(setting).rule || []), r => r.toLowerCase()) },
  },
  created: function() {
    console.log(`[${this.custom.slogan}]Report.wmds.vue`, `created`);
  },
  destroyed: function() { console.log(`[${this.custom.slogan}]Report.wmds.vue`, `destroyed`); },
  mounted: function() {
    this.custom = Custom.setting()
    console.log(`[${this.custom.slogan}]Report.wmds.vue`, `mounted`);
  },
}
</script>
